import styled from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  border: 1px solid #E3E3E3;
  width: 100%;
  background: #FFFFFF;
  padding: 16px;
`;

export default Wrapper(template);